// src/components/post-card/toolbar-icons.tsx
//
// `poll` and `mic` don't exist in your Icon component's OUTLINE/SOLID maps —
// and because Icon falls back SILENTLY to the grid glyph for any unrecognized
// name (`OUTLINE[n] ?? OUTLINE.grid`), both were rendering as a grid icon with
// no error to catch it. These two are drawn directly instead, so they render
// correctly no matter what's in your icon set. Same {s, c} shape as Icon,
// dropped in wherever `<Icon n="poll" .../>` or `<Icon n="mic" .../>` was.

export function PollGlyph({
  s = 20,
  c = "currentColor",
}: {
  s?: number;
  c?: string;
}) {
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill={c}
      style={{ flex: "none" }}
    >
      <rect x="3" y="10" width="4" height="10" rx="1" />
      <rect x="10" y="4" width="4" height="16" rx="1" />
      <rect x="17" y="7" width="4" height="13" rx="1" />
    </svg>
  );
}

export function MicGlyph({
  s = 20,
  c = "currentColor",
}: {
  s?: number;
  c?: string;
}) {
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill={c}
      style={{ flex: "none" }}
    >
      <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 1 0-6 0v6a3 3 0 0 0 3 3z" />
      <path d="M19 11a1 1 0 1 0-2 0 5 5 0 0 1-10 0 1 1 0 1 0-2 0 7 7 0 0 0 6 6.92V20H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-2.08A7 7 0 0 0 19 11z" />
    </svg>
  );
}

// Same reasoning as MicGlyph/PollGlyph above — drawn directly rather than
// guessed as an Icon name. Used by the live-streaming mic/camera toggles.
export function MicOffGlyph({
  s = 20,
  c = "currentColor",
}: {
  s?: number;
  c?: string;
}) {
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      stroke={c}
      strokeWidth={2}
      strokeLinecap="round"
      style={{ flex: "none" }}
    >
      <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 1 0-6 0v4" fill="none" />
      <path d="M19 11a7 7 0 0 1-7 7 7 7 0 0 1-3.5-.94" fill="none" />
      <path d="M5 11a7 7 0 0 0 1.68 4.56" fill="none" />
      <line x1="12" y1="18" x2="12" y2="22" />
      <line x1="9" y1="22" x2="15" y2="22" />
      <line x1="2" y1="2" x2="22" y2="22" />
    </svg>
  );
}

export function VideoGlyph({
  s = 20,
  c = "currentColor",
}: {
  s?: number;
  c?: string;
}) {
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill={c}
      style={{ flex: "none" }}
    >
      <rect x="2" y="6" width="14" height="12" rx="2.5" />
      <path d="M22 8.3v7.4a1 1 0 0 1-1.53.85L17 14.3V9.7l3.47-2.25A1 1 0 0 1 22 8.3z" />
    </svg>
  );
}

export function VideoOffGlyph({
  s = 20,
  c = "currentColor",
}: {
  s?: number;
  c?: string;
}) {
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      stroke={c}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flex: "none" }}
    >
      <path d="M16 8.3 20.47 6a1 1 0 0 1 1.53.85v8.4" />
      <path d="M2 6.5A2.5 2.5 0 0 1 4.5 4H14a2.5 2.5 0 0 1 2.5 2.5v3" />
      <path d="M16.5 17.5A2.5 2.5 0 0 1 14 20H4.5A2.5 2.5 0 0 1 2 17.5V9" />
      <line x1="2" y1="2" x2="22" y2="22" />
    </svg>
  );
}
